import { observer } from 'mobx-lite';
import { Box, Tooltip } from '@mui/material';
import { WifiOff, Wifi, Refresh } from '@mui/icons-material';
import { MainStoreContextItem } from '../Stores/MainStore';
import { ServiceConnectedState } from '../SocketServices/WebsocketStore';

export const WebSocketStatusIndicator = observer(() => {
    const store = MainStoreContextItem.useStore();
    const { serviceConnected } = store.websocketStore;

    // Only show when not online
    if (serviceConnected === ServiceConnectedState.Online) {
        return null;
    }

    const getStatusInfo = () => {
        switch (serviceConnected) {
            case ServiceConnectedState.Offline:
                return {
                    icon: <WifiOff />,
                    color: '#ff4444',
                    label: 'WebSocket Offline',
                    description: 'Connection to server is offline',
                };
            case ServiceConnectedState.Connecting:
                return {
                    icon: <Refresh />,
                    color: '#ffaa00',
                    label: 'WebSocket Connecting',
                    description: 'Connecting to server...',
                };
            case ServiceConnectedState.Reconnecting:
                return {
                    icon: <Refresh />,
                    color: '#ffaa00',
                    label: 'WebSocket Reconnecting',
                    description: 'Reconnecting to server...',
                };
            default:
                return {
                    icon: <Wifi />,
                    color: '#44ff44',
                    label: 'WebSocket Online',
                    description: 'Connected to server',
                };
        }
    };

    const status = getStatusInfo();

    return (
        <Tooltip
            title={status.description}
            placement="right"
            arrow
        >
            <Box
                style={{
                    position: 'fixed',
                    bottom: 20,
                    left: 20,
                    zIndex: 1001,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    borderRadius: '50%',
                    padding: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',  
                    border: `2px solid ${status.color}`,
                    backdropFilter: 'blur(10px)',
                    animation:
                        serviceConnected === ServiceConnectedState.Connecting ||
                        serviceConnected === ServiceConnectedState.Reconnecting
                            ? 'pulse 2s infinite'
                            : 'none',
                }}
            >
                <style>
                    {`
                        @keyframes pulse {
                            0%, 100% { opacity: 1; }
                            50% { opacity: 0.5; }
                        }
                    `}
                </style>
                <Box
                    component="span"
                    style={{
                        color: status.color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {status.icon}
                </Box>
            </Box>
        </Tooltip>
    );
});

WebSocketStatusIndicator.displayName = 'WebSocketStatusIndicator';
